module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    on: {
      "update:returnValue": _vm.setEditItemIdPermissionsZero
    },
    model: {
      value: (_vm.dialogPermissions),
      callback: function($$v) {
        _vm.dialogPermissions = $$v
      },
      expression: "dialogPermissions"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "text-md-center"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "label": "Select Permissions",
      "items": _vm.permissionsList
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('v-chip', [_c('span', [_vm._v(_vm._s(item.description || item.name))])])]
      }
    }]),
    model: {
      value: (_vm.selectedPermissions),
      callback: function($$v) {
        _vm.selectedPermissions = $$v
      },
      expression: "selectedPermissions"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemData(_vm.roleId)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f8bd651","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/AppEditRolesPermissionsDialog.vue
// module id = 952
// module chunks = 1